export const EC_FORM_SLUG = ''
export const EC_IN_PROGRESS_SLUG = 'in-progress'
export const EC_SUCCESS_SLUG = 'success'
export const EC_UPGRADE_SLUG = 'upgrade'
export const EC_COMPLETE_SLUG = 'complete'
export const EC_SLA_HOURS = 48
export const HOURS_IN_A_DAY = 24

export type ECSlug =
  | typeof EC_FORM_SLUG
  | typeof EC_IN_PROGRESS_SLUG
  | typeof EC_SUCCESS_SLUG
  | typeof EC_UPGRADE_SLUG
  | typeof EC_COMPLETE_SLUG

export const IN_APP_EC_FAQ_LINK =
  '//www.chegg.com/contactus?a=What-is-Expert-Proofreading---id--EZ41TgLJTW62xhv9cV4WNg'



// WEBPACK FOOTER //
// ./src/pages/ExpertCheck/constants.ts